import { useEffect, useState } from 'react'
import Button from '../../components/General/Button'
import InputText from '../../components/Inputs/InputText'
import axios from 'axios'
import placeholder from '../../assets/images/img-placeholder.jpg'
import { useHistory, useLocation } from 'react-router-dom'
import { FaArrowLeft } from 'react-icons/fa'

export const WarehousesView = () => {
  const server = process.env.REACT_APP_SERVER_URL

  const history = useHistory()

  const location = useLocation()

  const [loading, setLoading] = useState<boolean>(false)

  const [warehouses, setWarehouses] = useState<any[]>([])

  const data = location.state as any

  console.log('DATA', data)

  const getData = async () => {
    setLoading(true)
    try {
      const res = await axios.get(`${server}/inventory/warehouse`)
      setWarehouses(res.data.warehouses)
    } catch (error: any) {
      console.log(error?.message)
    }
    setLoading(false)
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <div className="h-full">
      <div className="flex flex-row justify-between items-center">
        <FaArrowLeft
          style={{ color: '#2961D0' }}
          onClick={() => history?.push('/inventory')}
        />
      </div>

      <div className="mt-5">
        <label className="font-medium">Almacén</label>
      </div>

      <div className="mt-5">
        {warehouses?.map((warehouse) => (
          <div className="bg-primary-100 p-3 rounded-sm" onClick={() => data?.type === "load" ? history?.push("/loadItems", warehouse) : history?.push("/unloadItems", warehouse)}>
            <div>
              <label className="font-medium text-primary text-sm">
                {warehouse?.name}
              </label>
            </div>

            <div>
              <label className="font-normal text-sm">
                {warehouse?.description}
              </label>
            </div>

            <div
              className="flex flex-row justify-center mt-4"
              style={{
                flexDirection: 'row',
                justifyContent: 'space-between',
                width: '100%',
              }}
            >
              <label
                style={{ color: '#a12175', fontSize: 14, fontWeight: 'bold' }}
              >{`${warehouse.numberOfExistences} artículos cargados`}</label>
              <label
                style={{ color: '#a12175', fontSize: 14, fontWeight: 'bold' }}
              >
                {warehouse.warehouseType === 'SALE FLOOR'
                  ? 'Piso de venta'
                  : 'Almacén'}
              </label>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
